<template>
    <div class="commerceClassroom-wrapper">
        <div class="content">
            <div class="main">
                <div class="logo">
                    <img src="@/assets/images/big-logo.png" alt="">
                </div>
                <h1>電商教室</h1>
            </div>
        </div>
        <div class="small-menu">
            <div class="main">
                <div class="list flex-start">
                    <div @click="gotosecond(item.title)" class="items flex-start" v-for="(item, index) in menu"
                        :key="index">
                        {{ item.title }}
                        <img class="icon" src="@/assets/images/up-icon.png" alt="">
                    </div>
                </div>
            </div>
        </div>
        <PopularPicks></PopularPicks>
        <SwiperNews></SwiperNews>
        <div class="main">
            <div class="new-list">
                <div class="left">
                    <!-- news -->
                    <div class="news">
                        <div class="title">最新文章</div>
                        <div class="list">
                            <div @click='gotodetail(item.id)' class="items" v-for="(item, index) in all_list.new"
                                :key="index">
                                <div class="img">
                                    <img :src="item.thumb" alt="">
                                </div>
                                <div class="bottom">
                                    <div class="name">{{ item.title }}</div>
                                    <div class="news-content">{{ item.subtitle }}</div>
                                    <div class="timer flex-start">
                                        <div class="tag" v-for="(child, childIndex) in item.tag" :key="childIndex">{{
                                            child }}</div>
                                        {{ item.time }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 網店行銷 -->
                    <div class="small-news">
                        <div class="title">網店行銷</div>
                        <div class="list flex-bt">
                            <div class="items" v-for="(item, index) in all_list['4']" :key="index">
                                <SmallNews :data="item"></SmallNews>
                            </div>
                        </div>
                    </div>
                    <!-- 品牌故事分享 -->
                    <div class="small-news">
                        <div class="title">品牌故事分享</div>
                        <div class="list flex-bt">
                            <div class="items" v-for="(item, index) in all_list['3']" :key="index">
                                <SmallNews :data="item"></SmallNews>
                            </div>
                        </div>
                    </div>
                    <!-- 最新電商功能 -->
                    <div class="small-news">
                        <div class="title">最新電商功能</div>
                        <div class="list flex-bt">
                            <div class="items" v-for="(item, index) in all_list['2']" :key="index">
                                <SmallNews :data="item"></SmallNews>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="right">
                    <div class="online-store">
                        <div class="title">網店實戰工作坊</div>
                        <div class="img">
                          <a target="_blank" :href="blogset.gzfurl" > <img :src="blogset.gzfjpg" alt=""></a> 
                        </div>
                        <div class="button-box flex-bt">
                            <div @click="changerightlist('hot')" :class="rightactive == 'hot' ? 'items' : 'items active'">
                                熱門文章
                            </div>
                            <div @click="changerightlist('tui')" :class="rightactive == 'tui' ? 'items' : 'items active'">
                                編輯推薦
                            </div>
                        </div>
                        <div class="small-list">
                            <div @click='gotodetail(item.id)' class="items flex-start" v-for="(item, index) in rightList"
                                :key="index">
                                <p class="num">{{ index + 1 }}</p>
                                <span>{{ item.title }}</span>
                            </div>
                        </div>
                    </div>
                    <!-- tag -->
                    <div class="tag-list">
                        <div class="title">Tag Cloud</div>
                        <div class="tag-box">
                            <template  v-if="item" v-for="(item, index) in all_list.tag">
                                <div class="items" v-if="item" :key="index">	
								<router-link   :to="'/commerceClassroomList?tag=' + item"> 
								<p style="color: black;">{{ item }}</p>
								</router-link>
                                </div>
                            </template>
                        </div>
                    </div>

                    <!-- about -->
                    <div class="about">
                        <div class="title">{{ blogset.zhuiTitle }}</div>
                        <div class="content-box">{{ blogset.guanyu }}</div>
                        <router-link to="/consultation">
                            <div class="button-box">立即預約</div>
                        </router-link>

                    </div>

                    <!--  -->
                    <div class="track">
                        <div class="title">追蹤LOOPSHOP</div>

                        <div class="list">
                            <iframe
                                src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Floopshop.hk&tabs=timeline&width=396&height=500&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=true&appId"
                                width="396" height="70" style="border:none;overflow:hidden" scrolling="no" frameborder="0"
                                allowfullscreen="true"
                                allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
                            <!-- <a target="_blank" :href="blogset.zhuiUrl" class="items flex-start">
                                <div class="logo"><img :src="blogset.zhuiImg"></img></div>
                                <div class="text">
                                    <div class="name">LOOPSHOP</div>
                                    <div class="text2">{{ blogset.zhuinum }}位追蹤者</div>
                                </div>
                            </a> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <AdBox></AdBox>
        <Start></Start>
    </div>
</template>
<script>
import PopularPicks from '@/components/PopularPicks.vue'
import SmallNews from '@/components/SmallNews.vue'
import Start from '@/components/Start.vue'
import AdBox from '@/components/AdBox.vue'
import SwiperNews from '@/components/SwiperNews.vue'
export default {
    components: { PopularPicks, SmallNews, Start, AdBox, SwiperNews },
    data() {
        return {
            all_list: {},
            rightList: [],
            blogset: [],
            rightactive: 'hot',
            menu: [

            ],
            list: [

            ],

            smallNewsList: [
                { title: '【新聞稿】發布《2023 香港開店白皮書》 展望後疫情時代四大電商市場趨勢', tag: ['2023 香港開店白皮書'], time: 'May 03, 2023' },
                { title: '【IG 新功能】IG 便利貼／IG Notes 功能教學 如何應用在品牌上？', tag: ['IG Notes', 'IG Shop'], time: 'May 03, 2023' },
                { title: '【IG 新功能】IG 便利貼／IG Notes 功能教學 如何應用在品牌上？', tag: ['IG Notes', 'IG Shop'], time: 'May 03, 2023' },
                { title: '6thfeb 如何使用 SHOPLINE IG LIVE 直播購物推進銷售？', tag: ['IG 直播'], time: 'May 03, 2023' },
            ],

            smallList: [
                { title: 'iOS 14 私隱政策 2021 更新：網店收入將受波及？即睇電商廣告應對策略！' },
                { title: 'iOS 14 私隱政策 2021 更新：網店收入將受波及？即睇電商廣告應對策略！' },
                { title: 'iOS 14 私隱政策 2021 更新：網店收入將受波及？即睇電商廣告應對策略！' },
                { title: 'iOS 14 私隱政策 2021 更新：網店收入將受波及？即睇電商廣告應對策略！' },
                { title: 'iOS 14 私隱政策 2021 更新：網店收入將受波及？即睇電商廣告應對策略！' },
            ],

            tag: [
                { name: 'TAG' },
                { name: 'TAG' },
                { name: 'TAG' },
                { name: 'TAG' },
                { name: 'TAG' },
                { name: 'TAG' },
                { name: 'TAG' },
                { name: 'TAG' },
                { name: 'TAG' },
                { name: 'TAG' },
                { name: 'TAG' },
                { name: 'TAG' },
                { name: 'TAG' },
                { name: 'TAG' },
                { name: 'TAG' },
                { name: 'TAG' },
                { name: 'TAG' },
                { name: 'TAG' },
                { name: 'TAG' },
                { name: 'TAG' },
                { name: 'TAG' },
            ]
        }
    },
    mounted() {

        this.getallList()
        this.getMenuList()
        this.getBlogSet()
        // this.getCaseList()
    },
    methods: {
        gotodetail(id) {
            this.$router.push('/newsDetail?id=' + id);
        },

        gotosecond(id) {
            this.$router.push('/commerceClassroomList?class_type=' + id);
        },

        changerightlist(item) {
            this.rightactive = item
            this.rightList = this.all_list[item]
        },
        async getallList() {
            this.showMoreBtn = false
            let fdata = { do: 'Makenewjson', sjk: '', orderby: 'id asc', limit: 10 }
            let res = await this.$api.funk(fdata)
            this.all_list = res
            this.rightList = this.all_list.hot
        },

        async getList() {
            this.showMoreBtn = false
            let fdata = { do: 'json', sjk: 'article', orderby: 'id asc', limit: 10 }
            let res = await this.$api.funk(fdata)
            this.themes = res
            this.nowthem = res[0]
        },

        async getMenuList() {
            this.showMoreBtn = false
            let fdata = { do: 'json', sjk: 'classtype', orderby: 'orderid asc', limit: 10 }
            let res = await this.$api.funk(fdata)
            this.menu = res

        },

        async getBlogSet() {

            let fdata = { do: 'getset', goto: 'blogset', orderby: 'orderid asc', limit: 10 }
            let res = await this.$api.funk(fdata)
            this.blogset = res

        },


    }
}
</script>
<style lang="scss" scoped>
.commerceClassroom-wrapper {
    iframe {
        width: 100%;
        display: block;
    }

    .new-list {
        display: flex;
        justify-content: space-between;
        margin-top: 0.76rem;
        width: 100%;

        .left {
            flex: 1;
            margin-right: 1rem;
        }

        .right {
            width: 26%;
        }

        .track {
            margin-top: 0.5rem;

            .title {
                font-family: 'PingFang HK';
                font-style: normal;
                font-weight: 400;
                font-size: 0.24rem;
                line-height: 0.32rem;
                color: #000000;
            }

            .list {
                width: 100%;
                background: #EBEBEB;
                margin-top: 0.16rem;

                .items {
                    width: 100%;
                    background: #D9D9D9;
                    padding: 0.16rem;

                    .logo {
                        width: 0.88rem;
                        height: 0.88rem;
                        background: #8B8B8B;
                        margin-right: 0.16rem;

                        img {
                            width: 100%;
                            height: 100%;
                            display: block;
                        }
                    }

                    .text {
                        height: 0.88rem;

                        .name {
                            font-family: 'PingFang HK';
                            font-style: normal;
                            font-weight: 400;
                            font-size: 0.24rem;
                            line-height: 0.32rem;
                            color: #000000;
                        }

                        .text2 {
                            font-family: 'PingFang HK';
                            font-style: normal;
                            font-weight: 400;
                            font-size: 0.24rem;
                            line-height: 0.32rem;
                            color: #000000;
                            margin-top: 0.08rem;
                        }
                    }
                }
            }
        }

        .about {
            margin-top: 0.5rem;

            .title {
                font-family: 'PingFang HK';
                font-style: normal;
                font-weight: 400;
                font-size: 0.24rem;
                line-height: 0.32rem;
                color: #000000;
            }

            .content-box {
                font-family: 'PingFang HK';
                font-style: normal;
                font-weight: 400;
                font-size: 0.12rem;
                line-height: 0.18rem;
                color: #000000;
                margin-top: 0.16rem;
            }

            .button-box {
                width: 100%;
                height: 0.64rem;
                background: #E02E43;
                border-radius: 0.08rem;
                text-align: center;
                font-family: 'PingFang HK';
                font-style: normal;
                font-weight: 600;
                font-size: 0.24rem;
                line-height: 0.64rem;
                color: #FFFFFF;
                margin-top: 0.16rem;
                cursor: pointer;
            }
        }

        .tag-list {
            margin-top: 0.4rem;

            .title {
                font-family: 'PingFang HK';
                font-style: normal;
                font-weight: 400;
                font-size: 0.24rem;
                line-height: 0.32rem;
                color: #000000;
                margin-bottom: 0.16rem;
            }

            .tag-box {
                display: flex;
                justify-content: flex-start;
                flex-wrap: wrap;

                .items {
                    font-family: 'PingFang HK';
                    font-style: normal;
                    font-weight: 400;
                    font-size: 0.16rem;
                    line-height: 0.22rem;
                    padding: 0.04rem 0.08rem;
                    color: #E02E43;
                    margin: 0 0.06rem 0.06rem 0;
                    border: 1px solid #E02E43;
                    border-radius: 4px;
                    cursor: pointer;

                    &:nth-child(7n) {
                        margin-right: 0px;
                    }
                }
            }
        }

        .online-store {
            .title {
                font-family: 'PingFang HK';
                font-style: normal;
                font-weight: 400;
                font-size: 0.24rem;
                line-height: 0.32rem;
                color: #000000;
                margin-bottom: 0.08rem;
            }

            .img {
                width: 100%;
                height: 3rem;

                img {
                    width: 100%;
                    display: block;
                }
            }

            .small-list {
                .items {
                    width: 100%;
                    height: 0.8rem;
                    border-bottom: 1px solid #CCCCCC;
                    cursor: pointer;

                    .num {
                        width: 0.4rem;
                        height: 0.4rem;
                        background: #E02E43;
                        text-align: center;
                        font-family: 'PingFang HK';
                        font-style: normal;
                        font-weight: 600;
                        font-size: 0.24rem;
                        line-height: 0.4rem;
                        text-align: center;
                        color: #FFFFFF;
                        margin-right: 0.16rem;
                    }

                    span {
                        font-family: 'PingFang HK';
                        font-style: normal;
                        font-weight: 400;
                        font-size: 0.16rem;
                        line-height: 0.22rem;
                        color: #000000;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        overflow: hidden;
                        -webkit-box-orient: vertical;
                        flex: 1;
                    }
                }
            }

            .button-box {
                margin-top: 0.4rem;

                .items {
                    width: 1.9rem;
                    height: 0.8rem;
                    background: #E02E43;
                    cursor: pointer;
                    font-family: 'PingFang HK';
                    font-style: normal;
                    font-weight: 400;
                    font-size: 0.24rem;
                    line-height: 0.8rem;
                    color: #fff;
                    text-align: center;

                    &.active {
                        background: #FAFAFA;
                        /* Red/100 */
                        border: 2px solid #E02E43;
                        color: #E02E43;
                    }
                }
            }
        }

        .small-news {
            margin-top: 0.8rem;

            .title {
                font-family: 'PingFang HK';
                font-style: normal;
                font-weight: 400;
                font-size: 0.24rem;
                line-height: 0.32rem;
                color: #000000;
                margin-bottom: 0.16rem;
            }

            .list {
                width: 100%;
                flex-wrap: wrap;
                align-items: inherit;

                .items {
                    margin-bottom: 0.4rem;
                }
            }
        }

        .news {

            .title {
                font-family: 'PingFang HK';
                font-style: normal;
                font-weight: 400;
                font-size: 0.24rem;
                line-height: 0.32rem;
                color: #000000;
                margin-bottom: 0.08rem;
            }

            .list {
                width: 8.4rem;

                .items {
                    background: #F5FAFA;
                    height: 5.92rem;
                    margin-bottom: 0.4rem;
                    cursor: pointer;

                    &:last-child {
                        margin-bottom: 0;
                    }

                    .img {
                        width: 100%;
                        height: 4.2rem;
                        overflow: hidden;

                        img {
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                        }
                    }

                    .bottom {
                        padding: 0.16rem;

                        .news-content {
                            font-family: 'PingFang HK';
                            font-style: normal;
                            font-weight: 400;
                            font-size: 12px;
                            line-height: 0.18rem;
                            color: #000000;
                            margin-top: 0.16rem;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp: 2;
                            overflow: hidden;
                            -webkit-box-orient: vertical;
                        }

                        .name {
                            font-family: 'PingFang HK';
                            font-style: normal;
                            font-weight: 600;
                            font-size: 0.18rem;
                            line-height: 0.22rem;
                            color: #000000;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp: 2;
                            overflow: hidden;
                            -webkit-box-orient: vertical;
                        }

                        .timer {
                            font-family: 'PingFang HK';
                            font-style: normal;
                            font-weight: 400;
                            font-size: 0.12rem;
                            line-height: 0.12rem;
                            color: #000000;
                            margin-top: 0.42rem;

                            .tag {
                                border: 1px solid #E02E43;
                                border-radius: 0.04rem;
                                padding: 0.04rem;
                                font-family: 'PingFang HK';
                                font-style: normal;
                                font-weight: 400;
                                font-size: 0.12rem;
                                line-height: 0.12rem;
                                color: #E02E43;
                                margin-right: 0.12rem;
                            }
                        }
                    }
                }
            }
        }
    }

    .small-menu {
        width: 100%;
        height: 0.64rem;
        background: #E02E43;

        .list {
            height: 0.64rem;

            .items {
                font-family: 'PingFang HK';
                font-style: normal;
                font-weight: 400;
                font-size: 0.2rem;
                line-height: 0.2rem;
                color: #FFFFFF;
                margin-right: 0.4rem;
                height: 100%;
                cursor: pointer;

                .icon {
                    width: 0.24rem;
                    height: 0.24rem;
                    margin-left: 0.08rem;
                }
            }
        }
    }

    .content {
        width: 100%;
        height: 3.4rem;
        background: url('~@/assets/images/commerceClassroom-bgs.png')no-repeat center center /100% 100%;
        padding-top: 0.86rem;

        .logo {
            height: 0.8rem;
            width: 1.74rem;
            margin: 0 auto;

            img {
                width: 100%;
                height: 100%;
                display: block;
            }
        }

        h1 {
            width: 100%;
            text-align: center;
            font-family: 'PingFang HK';
            font-style: normal;
            font-weight: 600;
            font-size: 0.56rem;
            line-height: 0.78rem;
            letter-spacing: 0.05em;
            color: #000000;
            margin-top: 0.12rem;
        }
    }
}


@media (max-width: 750px) {
    .commerceClassroom-wrapper .small-menu .list .items {
        display: none;
    }

    .commerceClassroom-wrapper .new-list {
        display: block;
    }

    .commerceClassroom-wrapper .new-list .right {
        width: 100%;
    }

    .commerceClassroom-wrapper .new-list .online-store .img {
        overflow: hidden;
        height: auto;
    }

    .commerceClassroom-wrapper .new-list .online-store .button-box {
        margin-bottom: 0.4rem;
    }

    .commerceClassroom-wrapper .new-list .online-store .button-box .items {
        width: 48%;
        font-size: 0.32rem;
    }

    .commerceClassroom-wrapper .new-list .online-store .small-list .items span {
        line-height: 0.34rem;
        font-size: 0.28rem;
    }

    .commerceClassroom-wrapper .new-list .online-store .small-list .items .num {
        width: 0.6rem;
        height: 0.6rem;
        line-height: 0.6rem;
        font-size: 0.28rem;
    }

    .commerceClassroom-wrapper .new-list .online-store .small-list .items {
        height: 1.2rem;
    }

    .commerceClassroom-wrapper .new-list .online-store .title {
        font-size: 0.3rem;
        margin-bottom: 0.2rem;
    }

    .commerceClassroom-wrapper .new-list .about .title {
        font-size: 0.3rem;
    }

    .commerceClassroom-wrapper .new-list .about .content-box {
        font-size: 0.26rem;
        line-height: 0.34rem;
    }

    .commerceClassroom-wrapper .new-list .about .button-box {
        height: 1rem;
        font-size: 0.32rem;
        line-height: 1rem;
    }

    .commerceClassroom-wrapper .new-list .tag-list .title {
        font-size: 0.3rem;
        margin-bottom: 0.2rem;
    }

    .commerceClassroom-wrapper .new-list .left {
        width: 100%;
    }

    .commerceClassroom-wrapper .new-list .news .list .items {
        width: 100%;
        height: auto;
    }

    .commerceClassroom-wrapper .new-list .news .list {
        width: 100%;
    }

    .commerceClassroom-wrapper .new-list .news .list .items .bottom .name {
        font-size: 0.24rem;
        line-height: 0.4rem;
    }

    .commerceClassroom-wrapper .new-list .news .list .items .bottom .news-content {
        font-size: 0.2rem;
        line-height: 0.3rem;
    }

    .commerceClassroom-wrapper .new-list .news .list .items .bottom .timer .tag {
        padding: 0.1rem 0.06rem;
    }

    .commerceClassroom-wrapper .new-list .news .title {
        font-size: 0.48rem;
        line-height: 0.48rem;
        margin-bottom: 0.4rem;
    }

    .commerceClassroom-wrapper .new-list .small-news .title {
        font-size: 0.48rem;
        line-height: 0.48rem;
        margin-bottom: 0.4rem;
    }


    .commerceClassroom-wrapper .new-list .small-news .list {
        display: block;
    }

    .commerceClassroom-wrapper .new-list .small-news .list .items {
        width: 100%;
    }

    .small-news-wrapper {
        width: 100%;
        height: auto;
    }

    .popularPicks-wrapper .list {
        width: 100%;
        overflow-x: scroll;
    }


}
</style>